import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'motn-login-help-buttons',
  templateUrl: './login-help-buttons.component.html',
  styleUrls: ['./login-help-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
  ],
})
export class LoginHelpButtonsComponent implements OnInit {
  @Input() excludeButtons: Array<'go-to-login' | 'forgot-username' | 'forgot-password' | 'need-register' | 'need-help'> = ['go-to-login'];


  constructor() {
  }


  ngOnInit(): void {
  }

}
